import type { City, GeoAddress } from '@features/cities/types'
import type { CityDto, GeoAddressDto } from '@shared/api/cities.dto'

/** Преобразует backend DTO города в доменную модель. */
export const mapCityDto = (dto: CityDto): City => ({
  name: dto.name,
  domain: dto.domain,
  domainPrefix: dto.domain_prefix,
  visibleName: dto.visible_name,
  country: {
    name: dto.country.name,
    code: dto.country.code,
    currency: {
      code: dto.country.currency.code,
      symbol: dto.country.currency.symbol,
    },
  },
})

/** Преобразует список backend DTO городов в доменные модели. */
export const mapCitiesDto = (dto: CityDto[]): City[] =>
  (dto ?? []).map(mapCityDto)

/** Преобразует backend DTO адреса в доменную модель. */
export const mapGeoAddressDto = (dto: GeoAddressDto): GeoAddress => ({
  city: dto.city,
  locality: dto.locality,
})
